<template>

    <b-modal id="my-quizzes-import-data-modal" centered>
        <template #modal-title>{{ t.__('Importuj dane z pliku') }}</template>

        <div class="row">

            <div class="col-3">
                <div class="form-group">
                    <label for="splitting-char">{{ t.__('Znak rozdzielający') }}</label>
                    <select id="splitting-char" class="form-control splitting-char-select" v-model="splittingCharOption" @change="readFileAndGetContent">
                        <option value="tabulator">{{ t.__('Tabulatura') }} (tab)</option>
                        <option value="semicolon">{{ t.__('Średnik') }} (;)</option>
                        <option value="colon">{{ t.__('Dwukropek') }} (:)</option>
                        <option value="pipe">{{ t.__('Kreska pionowa') }} (|)</option>
                    </select>
                </div>
            </div>

            <div class="col-9">
                <div class="form-group">
                    <label>{{ t.__('Plik') }}</label>
                    <div class="input-group file-select">
                        <span class="input-group-prepend">
                            <label class="btn btn-primary btn-file">
                                {{ fileName ? t.__('Zmień') : t.__('Wybierz') }} <input type="file" accept=".csv,.txt" class="d-none" @change="readFileAndGetContent" ref="fileInput">
                            </label>
                        </span>
                        <input type="text" class="form-control" :placeholder="t.__('Nie wybrano pliku')" :value="fileName" readonly />
                        <span class="input-group-append" v-if="fileName">
                             <button class="btn btn-warning btn-reset" type="button" @click="reset">{{ t.__('Resetuj') }}</button>
                        </span>
                    </div>
                    <p class="helper-text">
                        {{ t.__('Wybierz plik tekstowy z roszerzeniem .csv lub .txt.') }}<br>
                        {{ t.__('Plik powienien zawierać wiersze składające się z %d kolumn.', columnsCount) }}
                    </p>
                </div>
            </div>

        </div>

        <div class="recognized-rows-count" v-if="fileContent">{{ t.__('Liczba rozpoznanych wierszy') }}: {{ fileContent.length }}</div>

        <div class="alert alert-danger" v-if="error">{{ t.__('Nie udało się odczytać pliku') }}</div>

        <div class="recognized-rows-preview" v-if="fileContent && fileContent.length > 0">
            <div class="title">{{ t.__('Podgląd rozpoznanych danych') }}</div>
            <div class="table-responsive">
                <table class="table table-sm table-bordered">
                    <thead>
                    <tr>
                        <th v-for="name in columns" scope="col">{{ name }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in fileContent">
                        <td v-for="col in row">{{ col }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <template #modal-footer>
            <b-button variant="secondary" @click="close">{{ t.__('Anuluj') }}</b-button>
            <b-button variant="success" @click="importData" :disabled="fileContent === null || fileContent.length === 0">{{ t.__('Importuj') }}</b-button>
        </template>
    </b-modal>

</template>

<script>

export default {

    name: 'MyQuizzesImportDataModal',

    props: ['columns'],

    data() {
        return {
            eventHub: window.eventHub,
            splittingCharOption: 'tabulator',
            file: null,
            fileName: null,
            fileContent: null,
            error: false
        }
    },

    computed: {

        columnsCount() {
            return this.columns.length;
        }

    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-show-import-data-modal', () => {
            this.$bvModal.show('my-quizzes-import-data-modal')
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-import-data-modal') {
                this.reset();
            }
        });

    },

    methods:  {

        close() {
            this.$bvModal.hide('my-quizzes-import-data-modal');
        },

        importData() {
            this.$emit('import', this.fileContent);
            this.close();
        },

        readFileAndGetContent() {
            this.error = false;

            const file = this.$refs.fileInput !== undefined ? this.$refs.fileInput.files[0] : null;
            const extension = file.name.split('.').pop().toLowerCase();
            console.log(extension);

            if (extension !== 'csv' && extension !== 'txt') {
                this.reset();
                this.error = true;
                return;
            }

            if (file) {
                const reader = new FileReader();
                this.fileName = file.name;
                reader.onload = (e) => {
                    this.fileContent = [];
                    let splittingChar;
                    switch (this.splittingCharOption) {
                        case 'tabulator':
                            splittingChar = "\t";
                            break;
                        case 'semicolon':
                            splittingChar = ";";
                            break;
                        case 'colon':
                            splittingChar = ":";
                            break;
                        case 'pipe':
                            splittingChar = "|";
                            break;
                        default:
                            return;
                    }
                    let lines = e.target.result.split("\n");
                    lines.forEach((line) => {
                        let lineData = line.split(splittingChar);
                        if (lineData.length === this.columnsCount) {
                            lineData = lineData.map(col => col.trim());
                            this.fileContent.push(lineData);
                        }
                    });
                };
                reader.readAsText(file);
            }
        },

        reset() {
            this.splittingCharOption = 'tabulator';
            this.file = null;
            if (this.$refs.fileInput !== undefined) {
                this.$refs.fileInput.value = '';
            }
            this.fileName = null;
            this.fileContent = null;
            this.error = false;
        },

    }

}

</script>

<style scoped>

    .splitting-char-select {
        height: 43px;
    }

    .file-select label {
        color: #ffffff;
        padding: 0.5rem 2rem;
        height: 43px;
        margin-bottom: 0;
    }

    .file-select .form-control {
        height: 43px;
        border-color: #ced4da;
        border-radius: 0;
    }

    .file-select .form-control:focus {
        box-shadow: none;
    }

    .file-select .btn-reset {
        height: 43px;
        padding: 0.5rem 2rem;
    }

    .helper-text {
        font-size: 0.8rem;
        color: #6D6E71;
        margin-top: 5px;
    }

    .recognized-rows-count {
        font-size: 0.8rem;
        color: #6D6E71;
        margin-bottom: 20px;
    }

    .recognized-rows-preview .title {
        font-size: 0.8rem;
        color: #6D6E71;
        margin-bottom: 10px;
    }

    .recognized-rows-preview .table-responsive {
        max-height: 200px;
    }

    .recognized-rows-preview .table {
        font-size: 0.8rem;
        color: #6D6E71;
        white-space: nowrap;
    }

    .alert {
        font-size: 0.8rem;
    }

</style>
